module.exports = __webpack_public_path__ + "img/productBgImg16.00d8f417.png";